import React from 'react'
import image from 'assets/giphy.gif'

export default function ({ size = 40, style }: { size?: number; style?: React.CSSProperties }) {
  return <img src={image} width={size} height="auto" style={style} alt="logo spinner" />
}
